import Logger from '@/core/utils/logging';

import BaseService from './BaseService';

export default class WebhookService extends BaseService {
    pageLoad = async (corp: string) => {
        try {
            await fetch(
                `${window.rapidstor_settings.rapidstor_options.baseURL}/rapidstor/${corp}/${this._location.token}/api/webhook-event/pageLoad`,
                {
                    method: 'POST',
                    body: JSON.stringify({
                        data: {
                            corpCode: this._location.corpCode,
                            locationCode: this._location.locationCode,
                        },
                    }),
                },
            );
        } catch (err) {
            this.handleError(JSON.stringify(err));
        }
    };

    handleError = (error: string) => {
        Logger.error(`Error thrown in WebhookService: ${error}`, this._location);
    };
}
